import { render, staticRenderFns } from "./warehousePrices.vue?vue&type=template&id=8dae63d4&scoped=true"
import script from "./warehousePrices.vue?vue&type=script&lang=js"
export * from "./warehousePrices.vue?vue&type=script&lang=js"
import style0 from "./warehousePrices.vue?vue&type=style&index=0&id=8dae63d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dae63d4",
  null
  
)

export default component.exports